/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React, { forwardRef } from 'react';
import styles from './Input.module.css';
const Input = forwardRef(({
    type = 'text',
    value,
    onChange,
    placeholder,
    disabled = false,
    className = '',
    variant = 'default',
    ...props
}, ref) => {
    const inputClasses = [
        styles.input,
        styles[type === 'color' ? 'colorInput' : 'textInput'],
        styles[variant],
        className
    ].filter(Boolean).join(' ');
    return (
        <input
            ref={ref}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            className={inputClasses}
            spellCheck="false"
            {...props}
        />
    );
});
Input.displayName = 'Input';
export default Input;
